import { ChecklistAttachmentEntity } from "../../entities/ChecklistEntity";
import { ChecklistRepository } from "../../repositories/ChecklistRepository";

/**
 * Upload Attachment Use Case
 * Uploads an attachment (screenshot) for a checklist item
 */
export class UploadAttachmentUseCase {
  constructor(private repository: ChecklistRepository) {}

  async execute(
    itemId: number,
    file: File
  ): Promise<ChecklistAttachmentEntity> {
    return await this.repository.uploadAttachment(itemId, file);
  }
}

